var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "107px",
    viewBox: "0 0 139 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layout/Thumbnails/three-column") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout/Thumbnails/three-column",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bkgrd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "White",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 139,
    height: 107
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bkgrd-Elements",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DEDEDE",
    x: 0,
    y: 0,
    width: 139,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#979797",
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DEDEDE",
    x: 0,
    y: 18,
    width: 3,
    height: 81
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Areas",
    transform: "translate(10.000000, 33.000000)",
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 43,
    y: 0,
    width: 36,
    height: 66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 36,
    height: 66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 86,
    y: 0,
    width: 36,
    height: 66
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(10.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 35,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 31.25,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 29.25,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 28.25,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 25.25,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 22.5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F4F",
    x: 0,
    y: 0,
    width: 18.125,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 15.75,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9E9E9E",
    x: 0,
    y: 0,
    width: 6.625,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#707070",
    x: 0,
    y: 0,
    width: 5.625,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F4F",
    x: 0,
    y: 0,
    width: 4.25,
    height: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeColumn);
export default __webpack_public_path__ + "static/media/three-column.cfaf117b20e9b580fcb507cd9ce93a76.svg";
export { ForwardRef as ReactComponent };